@let ref = refSg();
@let info =
  currentRendering.subfeatures.widgets.selectors.getEntry(ref).asSignal();

<!-- TODO: The `loading` input is a temporary workaround to show a loading state
instead of an empty state when `info` is undefined. Ideally, this should be
handled within the current rendering logic, ensuring the `info` object is
initialized alongside the widget reference, with `loading` initially set to
true. -->
<atn-mosaic-widget
  [refId]="ref.id"
  [rendering]="info?.rendering"
  [loading]="info?.isLoading ?? true"
  [error]="info?.error?.message"
/>
